(async () => {
    const { Core, Events } = Global;

    customElements.define('matrix-table', class extends Core {

        render() {
          var variantTableInput = this.querySelectorAll('.productMatrix .variant-row .variant-input .qty');
          var variantTableSizes = this.querySelectorAll('.productMatrix thead > tr .size-column');
          var variantTableButton = this.querySelector('.form-action-addToCart');
          if (variantTableInput.length) {
            var variantTableButton = this.querySelector('.form-action-addToCart'); 
            variantTableInput.forEach(function (item) {
              item.addEventListener('focus', function(e){
                var itemText = this.closest('.variant-input').querySelector('.stock-text');
                var itemColorValue = this.closest('.variant-row').querySelector('.variant-colour');
                itemText.classList.add('hide');
                itemColorValue.classList.add('active');
                var currentRowItems = this.closest('.variant-row').querySelectorAll('.variant-input .qty');
                currentRowItems.forEach(function (el,index) {
                  if (item == el) {
                    variantTableSizes[index].classList.add('active');
                  }
                });
              });

              item.addEventListener('blur', function(e){
                var inputsValues = [];
                var itemText = this.closest('.variant-input').querySelector('.stock-text');
                var itemColorValue = this.closest('.variant-row').querySelector('.variant-colour');
                if (this.value == '') {
                  itemText.classList.remove('hide');
                }
                itemColorValue.classList.remove('active');
                var currentRowItems = this.closest('.variant-row').querySelectorAll('.variant-input .qty');
                currentRowItems.forEach(function (el,index) {
                  if (item == el) {
                    variantTableSizes[index].classList.remove('active');
                  }
                });
                variantTableInput.forEach(function (el) {
                  if (el.value != '') {
                    inputsValues.push(el.value);
                  }
                });
                if (variantTableButton != null) {
                  if (inputsValues.length > 0) {
                    variantTableButton.innerHTML = window.variantStrings.matrixTableButtonEnable;
                    variantTableButton.classList.add('active');
                    variantTableButton.removeAttribute('disabled');
                  } else {
                    variantTableButton.innerHTML = window.variantStrings.matrixTableButtonDisable;
                    variantTableButton.classList.remove('active');
                    variantTableButton.setAttribute('disabled', '');
                  }
                }
              });

             
               item.addEventListener('change', function(e){
                  var foundFilledInput = false;
                  variantTableInput.forEach(function (input) {
                    var value = input.value;
                    if(value != ""){
                      foundFilledInput = true
                    }
                  });

                if(variantTableButton){
                   if(foundFilledInput){
                     variantTableButton.removeAttribute("disabled");
                   }else{
                     variantTableButton.setAttribute("disabled","disabled");
                   }
                }
              });


              
            });

             if(variantTableButton){
              variantTableButton.addEventListener('click', function(e){
                console.log("work");

                var itemsObj = {'items': []};
                  variantTableInput.forEach(function (input) {
                    var value = input.value;
                    if(value != ""){
                      var variantID = input.getAttribute("data-variant");
                      var item = {
                         'id': variantID,
                         'quantity': value
                      }
                      itemsObj.items.push(item);
                      
                    }               
                  });

                     fetch(`${window.dynamicURLs.cartAdd}.js`, {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json',
                          'Accept': 'application/json'
                      },
                      body: JSON.stringify(itemsObj)
                      }).then((response) => {
                         if(!response.ok) {
                         throw new Error(response.json());
                         }else{
                            return window.location.href = window.dynamicURLs.cart;
                            //return response.json();
                         }  
                         
                        })
              });
             }
          }
        }

    })
})();